var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 5,
    className: "circle_svg__icon",
    style: {
      margin: 0
    },
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 512a100 100 0 1 0 1024 0A100 100 0 1 0 0 512",
    className: "circle_svg__selected",
    "data-spm-anchor-id": "a313x.search_index.0.i0.64ed3a81ac1THB"
  })));
};
export default SvgCircle;